export default __webpack_public_path__ + "static/media/Book_3.0a40d2cb.png";